import { ComponentProps, ReactNode, useRef, useState } from 'react'

import { Typography } from '@/components/ui/typography'

import { Tooltip } from '../tooltip'

interface TableCellProps {
  children: ReactNode
  breakLines?: number | boolean
  color?: ComponentProps<typeof Typography>['color']
}

export const TableCell = ({ children, breakLines = true, color = 'black500' }: TableCellProps) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const checkTruncation = () => {
    if (!textRef.current) return
    setIsTruncated(
      typeof breakLines === 'number' && breakLines > 1
        ? textRef.current.scrollHeight > textRef.current.clientHeight
        : textRef.current.scrollWidth > textRef.current.clientWidth,
    )
  }

  // Note: Only show tooltip for simple text content
  const isSimpleText = typeof children === 'string' || typeof children === 'number'

  if (!isSimpleText) {
    return <>{children}</>
  }

  return (
    <Tooltip
      disabled={!isTruncated}
      trigger={
        <Typography
          ref={textRef}
          breakLines={breakLines}
          size="text-small"
          weight="medium"
          as="span"
          whiteSpace="pre-line"
          color={color}
          onMouseEnter={checkTruncation}
        >
          {children}
        </Typography>
      }
    >
      {children}
    </Tooltip>
  )
}
